import axios from 'axios';

const apiService = axios.create({
  baseURL: 'https://facturacion.driveapp.mx/api',
});

export default apiService;
